import React, { FC, memo } from "react";

import { IJobRequest } from "@/data/job-requests";
import { ILanguageWithLevel } from "@/data/languages";
import { ISkillWithPriority } from "@/data/skills";
import { useCodelistTranslation } from "@/hooks/Codelist";
import { DEFAULT_VISIBLE_SKILLS_COUNT, SkillsList } from "@/views/components/Skills";

interface ISkillProps {
  label?: string;
  skills: IJobRequest["skills"];
}

interface ILanguagesProps {
  label?: string;
  languages: IJobRequest["languages"];
}

interface IJobRequestSkillsProps extends Pick<ISkillProps, "skills"> {
  clickable?: boolean;
  showMore?: boolean;
  visibleSkillsCount?: number;
}

const getSkillKey = (s: ISkillWithPriority) => `skill-${s.skill.id}`;
const getSkillText = (s: ISkillWithPriority) => s.skill.name;

export const JobRequestSkills: FC<IJobRequestSkillsProps> = memo(
  ({ skills, clickable = true, showMore = true, visibleSkillsCount = DEFAULT_VISIBLE_SKILLS_COUNT }) => {
    return (
      <SkillsList
        list={skills}
        getKey={getSkillKey}
        getText={getSkillText}
        showMore={showMore}
        visibleSkillsCount={visibleSkillsCount}
        clickable={clickable}
      />
    );
  },
);

const getLanguageKey = (l: ILanguageWithLevel) => `language-${l.id}`;

export const JobRequestLanguages: FC<ILanguagesProps> = memo(({ languages }) => {
  const tCodelist = useCodelistTranslation();

  return (
    <SkillsList
      list={languages}
      getKey={getLanguageKey}
      getText={l => tCodelist("languages", l.language)}
      getLevelText={l => tCodelist("language-levels", l.level)}
    />
  );
});
